import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { AppearanceControls } from "@/components/appearance-controls";
import { authSnapshot } from "@/stores/auth";

export const Route = createFileRoute("/_auth")({
  beforeLoad: () => {
    // Someone already signed in has no business on the sign-in screen.
    if (authSnapshot().accessToken) throw redirect({ to: "/" });
  },
  component: AuthLayout,
});

/**
 * Chrome only: the controls that sit on every signed-out screen. Each page owns
 * its own layout, because the sign-in and reset screens are shaped differently.
 * The controls are pinned to the bottom-left corner, as the legacy screens have
 * them; pages leave room at the bottom so a short screen does not cover a field.
 */
function AuthLayout() {
  return (
    <div className="bg-canvas flex min-h-dvh flex-col">
      <div className="flex flex-1 flex-col">
        <Outlet />
      </div>

      <AppearanceControls />
    </div>
  );
}
